export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 4